var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import { convertCurrency } from '../services/currency';
import cloneDeep from 'lodash/cloneDeep';
import { capitalize, currencyCodes } from './utils';
import Flag from 'react-world-flags';
import React from 'react';
export var getLowestLevelHeaders = function getLowestLevelHeaders(header) {
  if (header && header.children) {
    var nested = header.children.find(function (child) {
      return child.isParent && child.children;
    });
    if (!nested) return header.children;
    return getLowestLevelHeaders(nested);
  }

  return null;
};
export var toggleChildrenShowByParent = function toggleChildrenShowByParent(list, show, showHeaders, isPivoting) {
  list.forEach(function (header) {
    if (showHeaders[header.name]) {
      showHeaders[header.name].show = show;
    }

    if (!isPivoting && header.children) {
      showHeaders = toggleChildrenShowByParent(header.children, show, showHeaders, isPivoting);
    }
  });
  return showHeaders;
};
export var getDropdownOptionsForSku = function getDropdownOptionsForSku(headerList, isCatalogPrice) {
  return headerList && headerList.length && headerList.map(function (header) {
    if (header.isParent) {
      var isHeaderCatalogPrice = false;

      if (header.name.toLowerCase() === 'catalog price') {
        isHeaderCatalogPrice = true;
      }

      return getDropdownOptionsForSku(header.children, isHeaderCatalogPrice);
    }

    var label = capitalize(header.name);

    if (isCatalogPrice) {
      label += '-Catalog Price';
    }

    return {
      value: header.value,
      label: label,
      name: label,
      field: header.value
    };
  });
};
export var toggleHeaderFilter = function toggleHeaderFilter(headerList, payload, showHeaders, isPivoting) {
  headerList.forEach(function (header) {
    var key = header.name;
    var nested = header.children && header.children.find(function (child) {
      return child.isParent && child.children;
    });

    if (header.isParent && key === payload) {
      if (showHeaders[header.name]) {
        showHeaders[header.name].show = !showHeaders[header.name].show;

        if (!isPivoting || isPivoting && nested) {
          showHeaders = toggleChildrenShowByParent(header.children, showHeaders[header.name].show, showHeaders, isPivoting);
        }
      }
    } else if (header.isParent) {
      if (!isPivoting || isPivoting && nested) {
        var children = header.children;
        showHeaders = toggleHeaderFilter(children, payload, showHeaders, isPivoting);
        showHeaders = toggleParentIfAtleastOneChildShown(header, showHeaders);
      }
    } else if (!isPivoting && key === payload) {
      if (showHeaders[header.name]) {
        showHeaders[header.name].show = !showHeaders[header.name].show;
      }
    }
  });
  return showHeaders;
};
export var pivotingToggle = function pivotingToggle(headerList, showHeaders, payload, pivotHeaders) {
  if (showHeaders[payload]) {
    showHeaders[payload].show = !showHeaders[payload].show;
  }

  var pivotHeadersNotShown = pivotHeaders.filter(function (header) {
    return showHeaders[header.name] && !showHeaders[header.name].show;
  });

  if (pivotHeadersNotShown.length === pivotHeaders.length) {
    return false;
  }

  return showHeaders;
};

var toggleParentIfAtleastOneChildShown = function toggleParentIfAtleastOneChildShown(header, showHeaders) {
  var children = header.children;

  if (children) {
    var atleastOneChildShown = children && children.find(function (child) {
      return showHeaders[child.name] && showHeaders[child.name].show;
    });

    if (showHeaders[header.name]) {
      showHeaders[header.name].show = !!atleastOneChildShown;
    }
  }

  return showHeaders;
};

export var addShowToHeaders = function addShowToHeaders(headerList, showHeadersMap) {
  if (headerList && Array.isArray(headerList)) {
    headerList.forEach(function (header) {
      if (!showHeadersMap[header.name]) {
        if (header.name) {
          showHeadersMap[header.name] = {
            show: true,
            isParent: !!header.isParent
          };
        }
      }

      if (header.isParent) {
        addShowToHeaders(header.children, showHeadersMap);
      }
    });
  }

  return showHeadersMap;
};
export var getGridCellMaxLength = function getGridCellMaxLength(headerList) {
  var maxLength = 0;
  headerList.forEach(function (header) {
    if (header.isParent) {
      var childMax = getGridCellMaxLength(header.children);
      maxLength = Math.max(maxLength, childMax);
    } else if (header.name.length > maxLength) {
      maxLength = header.name.length;
    }
  });
  return maxLength;
};
export var updatePriceByBudgetRate = function updatePriceByBudgetRate(rowData, budgetRatesMap, selectedCurrency) {
  return rowData.map(function (row) {
    Object.keys(row).forEach(function (cell) {
      var value = row[cell];

      if (typeof value === 'object') {
        var productPrice_1 = value.productPrice,
            shippingPrice_1 = value.shippingPrice;

        if (productPrice_1 && productPrice_1.displayPrice) {
          var budgetRate = budgetRatesMap.find(function (obj) {
            return obj && obj.fromCurrency === productPrice_1.currency && obj.toCurrency === selectedCurrency;
          });

          if (!budgetRate) {
            budgetRate = budgetRatesMap.find(function (obj) {
              return obj && obj.fromCurrency === selectedCurrency && obj.toCurrency === productPrice_1.currency;
            });
          }

          var rate = budgetRate.rate;
          var displayPrice = productPrice_1.displayPrice,
              totalPrice = productPrice_1.totalPrice;
          value.productPrice = __assign(__assign({}, value.productPrice), {
            displayPrice: displayPrice * rate,
            totalPrice: totalPrice * rate,
            currency: selectedCurrency
          });

          if (shippingPrice_1 && shippingPrice_1.displayShippingPrice !== undefined) {
            // eslint-disable-next-line no-shadow
            var budgetRate_1 = budgetRatesMap.find(function (obj) {
              return obj && obj.fromCurrency === shippingPrice_1.currency && obj.toCurrency === selectedCurrency;
            });

            if (!budgetRate_1) {
              budgetRate_1 = budgetRatesMap.find(function (obj) {
                return obj && obj.fromCurrency === selectedCurrency && obj.toCurrency === shippingPrice_1.currency;
              });
            } // eslint-disable-next-line no-shadow


            var rate_1 = budgetRate_1.rate;
            var displayShippingPrice = shippingPrice_1.displayShippingPrice,
                totalShippingPrice = shippingPrice_1.totalShippingPrice;
            value.shippingPrice = __assign(__assign({}, value.shippingPrice), {
              displayShippingPrice: displayShippingPrice * rate_1,
              totalShippingPrice: totalShippingPrice * rate_1,
              currency: selectedCurrency
            });
          }
        }
      }
    });
    return row;
  });
};
export var getPinnedWidth = function getPinnedWidth(rowData, pinnedHeader) {
  var pinnedWidth = 150;
  var rowDataMaxLength = 16;

  if (rowData) {
    rowData.forEach(function (row) {
      var pinned = Object.values(row)[0];

      if (pinned) {
        if (rowDataMaxLength < pinned.toString().length) {
          rowDataMaxLength = pinned.toString().length;
        }
      }
    });
  }

  if (pinnedHeader) {
    rowDataMaxLength = Math.max(rowDataMaxLength, pinnedHeader.length);
  }

  if (rowDataMaxLength >= 17) {
    pinnedWidth = rowDataMaxLength * 2 + 160;
  }

  return pinnedWidth;
};
export var createBudgetRateMap = function createBudgetRateMap(rowData, selectedCurrency, fiscalYear) {
  return __awaiter(void 0, void 0, void 0, function () {
    var list, uniqueSet;
    return __generator(this, function (_a) {
      list = {};
      rowData.forEach(function (row) {
        Object.keys(row).forEach(function (cell) {
          var value = row[cell];

          if (typeof value === 'object') {
            var productPrice = value.productPrice,
                shippingPrice = value.shippingPrice;

            if (productPrice && productPrice.currency) {
              list[productPrice.currency] = true;

              if (shippingPrice && shippingPrice.currency) {
                list[shippingPrice.currency] = true;
              }
            }
          }
        });
      });
      uniqueSet = [];
      Object.keys(list).forEach(function (fromCurrency) {
        if (fromCurrency) {
          var obj_1 = {
            fromCurrency: fromCurrency,
            toCurrency: selectedCurrency.value,
            rate: null
          };
          var promise = Promise.all([convertCurrency(fromCurrency, selectedCurrency.value, fiscalYear), convertCurrency(selectedCurrency.value, fromCurrency, fiscalYear)]).then(function (budgetRates) {
            var _a;

            var rate = null;

            if (budgetRates[0] && budgetRates[0].rate) {
              _a = __read(budgetRates, 1), rate = _a[0].rate;
            } else if (budgetRates[1] && budgetRates[1].rate) {
              rate = 1 / budgetRates[1].rate;
            }

            return __assign(__assign({}, obj_1), {
              rate: rate
            });
          });
          uniqueSet.push(promise);
        }
      });
      return [2
      /*return*/
      , Promise.all(uniqueSet)];
    });
  });
};
export var changeRowDataByPriceMode = function changeRowDataByPriceMode(priceMode, rowData) {
  if (rowData) {
    rowData = cloneDeep(rowData);
    var newRowData = rowData && rowData.map(function (row) {
      Object.entries(row).forEach(function (_a) {
        var _b = __read(_a, 2),
            key = _b[0],
            value = _b[1];

        if (value && typeof value === 'object') {
          var productPrice = value.productPrice,
              quantity = value.quantity,
              shippingPrice = value.shippingPrice;

          if (productPrice && productPrice.displayPrice) {
            var displayPrice = productPrice.totalPrice;

            if (priceMode === 'unit') {
              displayPrice = productPrice.totalPrice / parseInt(quantity, 10);
            } // eslint-disable-next-line no-param-reassign


            value.productPrice = __assign(__assign({}, productPrice), {
              displayPrice: displayPrice
            });
          }

          if (shippingPrice && shippingPrice.displayShippingPrice) {
            var displayShippingPrice = shippingPrice.totalShippingPrice;

            if (priceMode === 'unit') {
              displayShippingPrice = shippingPrice.totalShippingPrice / parseInt(quantity, 10);
            } // eslint-disable-next-line no-param-reassign


            value.shippingPrice = __assign(__assign({}, shippingPrice), {
              displayShippingPrice: displayShippingPrice
            });
          }
        }
      });
      return row;
    });
    return newRowData;
  }

  return rowData;
};
export var getCurrencyOptions = function getCurrencyOptions() {
  return currencyCodes.map(function (_a) {
    var code = _a.code,
        symbol = _a.symbol;
    return {
      label: getCurrencyLabel(code, symbol),
      value: symbol
    };
  });
};

var getCurrencyLabel = function getCurrencyLabel(code, symbol) {
  return React.createElement("div", null, React.createElement(Flag, {
    className: "flag-icon",
    code: code,
    fallback: React.createElement("span", null, "Unknown")
  }), React.createElement("span", {
    className: "flag-text"
  }, symbol));
};